<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      toggled: false,
    };
  },
  methods: {
    confirm() {
      this.$emit('confirm');
      this.toggled = false;
    },
    cancel() {
      this.$emit('cancel');
      this.toggled = false;
    },
    open() {
      this.toggled = true;
    },
  },
};
</script>

<template>
  <v-dialog v-model="toggled" max-width="400px">
    <v-card>
      <v-flex font-weight-bold pa-3 title>
        <v-icon>warning</v-icon>
        {{ title }}
      </v-flex>
      <v-divider/>
      <v-flex pa-4>
        {{ description }}
      </v-flex>
      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="red darken-1"
          flat
          @click="cancel">
          {{ $t('dialog.actions.decline') }}
        </v-btn>
        <v-btn
          color="primary darken-1"
          flat
          @click="confirm">
          {{ $t('dialog.actions.confirm') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>



// WEBPACK FOOTER //
// src/components/TwConfirmDialog.vue